import one from "../../../../src/images/cellfina-1.jpg";
import two from "../../../../src/images/cellfina-2.jpg";
import three from "../../../../src/images/cellfina-3.jpg";
import * as React from 'react';
export default {
  one,
  two,
  three,
  React
};